import React from "react";
import "./App.scss";

import PersonList from "./Components/PersonList";

function App() {
  // Mock myPluginSettings for development
  const defaultSettings = {
    funeralHomeId: "",
    pageSize: 27,
    token: "",
    pluginUrl: "",
  };

  const myPluginSettings =
    typeof window.myPluginSettings !== "undefined"
      ? window.myPluginSettings
      : defaultSettings;

  return (
    <React.Fragment>
      <div className="condoleances-plugin">
        <PersonList myPluginSettings={myPluginSettings} />
      </div>
    </React.Fragment>
  );
}

export default App;
